import React from 'react'

const MailSvgIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={25}
    height={25}
    viewBox="0 0 25 25"
    fill="none"
  >
    <path
      d="M20.8333 4.16675H8.33333C7.18274 4.16675 6.25 5.09949 6.25 6.25008V15.6251C6.25 16.7757 7.18274 17.7084 8.33333 17.7084H20.8333C21.9839 17.7084 22.9167 16.7757 22.9167 15.6251V6.25008C22.9167 5.09949 21.9839 4.16675 20.8333 4.16675Z"
      stroke="#DD7744"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22.9154 7.29175L15.5195 11.2292C14.9258 11.5417 14.2383 11.5417 13.6445 11.2292L6.2487 7.29175M2.08203 8.33341V19.7917C2.08203 20.9376 3.01953 21.8751 4.16536 21.8751H18.7487"
      stroke="#DD7744"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default MailSvgIcon
